<template>
  <div class="us-mycertificate">
    <div class="container">
      <div class="us-mycertificate-content" :style="'backgroundColor:'+row.lineColor4">
        <div class="us-mc-flex">
          <img :src="row.image4" alt="">
          <div class="us-mycer-details">
            <div class="bg-title mb-3" v-html="row.title4"></div>
            <div class="text mb-3" v-html="row.body4"></div>
            <router-link v-if="row.button4" :to="row.redirect4" class="us-btn d-inline-block">
              <div class="d-flex align-items-center">{{ row.button4 }} <span class="icon-back"></span></div>
            </router-link>
          </div>
        </div>
        <div class="us-mc-line-inner" :style="'backgroundColor:'+row.line1Color4"></div>
        <div class="us-mc-line-outer" :style="'backgroundColor:'+row.line2Color4"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.us-mycertificate {
  margin-bottom: 110px;
}
.us-mycertificate-content {
  padding: 60px 0 80px;
  background: #9D0900;
  position: relative;
  border-bottom: 7px solid #fff;
}
.us-mc-flex {
  display: flex;
  justify-content: center;
}
.us-mycer-details {
  margin-left: 22px;
  padding-top: 10px;
}
.bg-title {
  color: #fff;
  font-size: 44px;
}
.text {
  font-weight: 500;
  color: #fff;
  font-size: 20px;
}
.us-btn {
  background: #FFFFFF;
  padding: 3px 15px;
  font-size: 15px;
  color: #001157;
}
.us-btn:hover {
  background: #ddd;
}
.us-btn:active {
  opacity: 0.7;
}
.icon-back:before {
  font-weight: bold;
  color: #001157;
}
.us-mc-line-inner,
.us-mc-line-outer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
}
.us-mc-line-outer {
  bottom: -15px;
  height: 10px;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
    .us-mc-flex img {
        width: 87px;
    }
    .us-mycertificate-content {
            padding: 30px 30px 70px;
    }
    .us-mycer-details {
        margin-left: 19px;
    }
    .bg-title {
        font-size: 25px;
        margin-bottom: 7px !important;
    }
    .text {
        font-size: 16px;
        margin-bottom: 11px !important;
    }
}

@media (max-width: 767.98px) {
  
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {

}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {

}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {

}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
export default {
  name: "Section2",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
